import { selectUserContext } from 'core/userContext';
import { SEARCH_PAGES } from 'modules/quickActionsMenu/constants';
import { useQuickActionsMenuContext } from 'modules/quickActionsMenu/contexts';
import { PAGE } from 'modules/quickActionsMenu/types';
import { doesUserHaveAccess } from 'modules/quickActionsMenu/utils';
import { useSelector } from 'react-redux';
import {
  ChevronRightSmall,
  EditDesign16,
  Handlebars16,
  KeyEnter,
  KeyTab,
  MultipleUsers16,
  SvgIconProps,
} from 'ui/icons';
import { Campaign16, Fragment16 } from 'ui/icons/aurora/16px/studio';
import { colors } from 'ui/theme';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { Action, Item } from '../Item';
import { CommandGroup } from '../Styled';

export const ITEMS_GROUP_TEXT = {
  heading: 'Items',
};

const { heading } = ITEMS_GROUP_TEXT;

/** defines ITEMS_GROUP_ITEMS to display in main section with search and navigation options */
export const ITEMS_GROUP_ITEMS: {
  Icon: (props: SvgIconProps) => JSX.Element;
  name: string;
  permissions: number[];
  url: string;
  value: string;
}[] = [
  {
    Icon: MultipleUsers16,
    name: 'Users',
    permissions: [PROJECT_PERMISSIONS.ViewAndExportUserData],
    url: '',
    value: SEARCH_PAGES[PAGE.USER_SEARCH].type,
  },
  {
    Icon: Campaign16,
    name: 'Campaigns',
    permissions: [PROJECT_PERMISSIONS.ViewMessaging],
    url: '/campaigns/manage',
    value: SEARCH_PAGES[PAGE.CAMPAIGN_SEARCH].type,
  },
  {
    Icon: Fragment16,
    name: 'Journeys',
    permissions: [PROJECT_PERMISSIONS.ViewMessaging],
    url: '/workflows',
    value: SEARCH_PAGES[PAGE.JOURNEY_SEARCH].type,
  },
  {
    Icon: EditDesign16,
    name: 'Templates',
    permissions: [],
    url: '/templates',
    value: SEARCH_PAGES[PAGE.TEMPLATE_SEARCH].type,
  },
  {
    Icon: Handlebars16,
    name: 'Snippets',
    permissions: [],
    url: '/templates/snippets',
    value: SEARCH_PAGES[PAGE.SNIPPET_SEARCH].type,
  },
];

export const ItemsGroup = () => {
  const { navigate } = useQuickActionsMenuContext();
  const { featureFlags = {}, rbacPermissions = [] } = useSelector(selectUserContext);

  const items = ITEMS_GROUP_ITEMS.filter((item) =>
    doesUserHaveAccess(item, rbacPermissions, featureFlags),
  );

  return (
    <CommandGroup heading={heading}>
      {items.map((item) => {
        const { Icon } = item;
        return (
          <Item
            Icon={<Icon isColorInherited />}
            key={item.value}
            name={item.name}
            onSelect={() => {
              if (item.url) {
                navigate({ pageName: item.name, path: item.url });
              }
            }}
            suffix={<ChevronRightSmall color={colors.iconPrimary} />}
            value={item.value}
          >
            <Action Key={<KeyTab isColorInherited />} prefix="Press" action="search" />
            {!!item.url && <Action Key={<KeyEnter isColorInherited />} action="view all" />}
          </Item>
        );
      })}
    </CommandGroup>
  );
};
